import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import axiosInstance from "../../../utils/axiosInstance";
import { formatDate } from "../../../utils/dateFormatter";
import { API_URL } from "../../../config";
import { useAuth } from "../../../Context/AuthContext";
import "./ViewEmployee.css";

function ViewEmployee() {
  const { employeeId } = useParams();
  const navigate = useNavigate();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [generatingCode, setGeneratingCode] = useState(false);
  const [updatingInterval, setUpdatingInterval] = useState(false);
  const [inactivityMonth, setInactivityMonth] = useState(new Date().getMonth() + 1);
  const [inactivityYear, setInactivityYear] = useState(new Date().getFullYear());
  const [inactivityDailyDate, setInactivityDailyDate] = useState(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  });
  const { user: currentUser } = useAuth();

  // Screenshots activity tracker state
  const [screenshots, setScreenshots] = useState([]);
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  });
  const [loadingScreenshots, setLoadingScreenshots] = useState(false);
  const [selectedScreenshot, setSelectedScreenshot] = useState(null);

  // Fetch screenshots when employee details or selected date change
  useEffect(() => {
    if (!employee || !employee._id) return;

    const fetchScreenshots = async () => {
      setLoadingScreenshots(true);
      try {
        const response = await axiosInstance.get(
          `/api/screenshots/employee/${employee._id}?date=${selectedDate}`
        );
        if (response.data.success) {
          setScreenshots(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching screenshots:", error);
      } finally {
        setLoadingScreenshots(false);
      }
    };

    fetchScreenshots();
  }, [employee, selectedDate]);

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      try {
        // Fetch this specific employee directly from DB (ensures latest screenshotInterval/inactivityTimeout)
        const response = await axiosInstance.get(`/api/getEmpDataByID/${employeeId}`);
        const emp = response.data;
        console.log("shdfusfbsf", emp);
        debugger

        if (emp && emp._id) {
          setEmployee(emp);
        } else {
          alert("Employee not found!");
          navigate("/admin/employee");
        }
      } catch (error) {
        console.error("Error fetching employee:", error);
        alert("Failed to fetch employee details");
      } finally {
        setLoading(false);
      }
    };

    fetchEmployeeDetails();
  }, [employeeId, navigate]);


  const handleGenerateCode = async () => {
    if (!employee || !employee._id) return;
    setGeneratingCode(true);
    try {
      const res = await axiosInstance.post("/api/generate-code", {
        employeeId: employee._id,
      });
      setEmployee({
        ...employee,
        isLocked: true,
        unlockOTP: res.data.code,
        inactivityLogoutCount: (employee.inactivityLogoutCount || 0) + 1,
        inactivityHistory: [...(employee.inactivityHistory || []), new Date().toISOString()]
      });
      alert(`New code generated: ${res.data.code}`);
    } catch (err) {
      console.error("Generate code error:", err);
      const errMsg = err.response?.data?.message || "Failed to generate code";
      alert(errMsg);
    } finally {
      setGeneratingCode(false);
    }
  };

  const handleUpdateSettings = async (type, newValue) => {
    if (!employee || !employee._id) return;
    setUpdatingInterval(true);
    const updateData = {};
    if (type === "interval") updateData.screenshotInterval = parseInt(newValue);
    if (type === "timeout") updateData.inactivityTimeout = parseInt(newValue);

    try {
      const response = await axiosInstance.put(`/api/updateOfficeTiming/${employee._id}`, updateData);
      console.log("fthftfytftyfy", response);
      debugger

      if (response.data.employee) {
        setEmployee(response.data.employee);
      } else {
        setEmployee({
          ...employee,
          ...updateData
        });
      }
      alert("Settings updated successfully!");
    } catch (err) {
      console.error("Update settings error:", err);
      alert("Failed to update settings");
    } finally {
      setUpdatingInterval(false);
    }
  };

  const handleDeleteScreenshot = async (id) => {
    if (!window.confirm("Are you sure you want to delete this screenshot?")) return;
    try {
      await axiosInstance.delete(`/api/screenshots/${id}`);
      setScreenshots(screenshots.filter((s) => s._id !== id));
      if (selectedScreenshot && selectedScreenshot._id === id) {
        setSelectedScreenshot(null);
      }
    } catch (err) {
      console.error("Delete screenshot error:", err);
      alert("Failed to delete screenshot");
    }
  };

  if (loading) {
    return (
      <div className="ve-state-wrap d-flex justify-content-center align-items-center">
        <div className="spinner-border ve-spinner" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!employee) {
    return (
      <div className="ve-state-wrap container py-5">
        <div className="alert alert-danger">Employee not found!</div>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4 view-employee-page">
      <div className="d-flex justify-content-between align-items-center mb-4 ve-topbar">
        <button onClick={() => navigate("/admin/employee")} className="btn ve-btn ve-btn-secondary">
          Back to List
        </button>
        <div className="d-flex gap-2">
          <button
            onClick={() => navigate(`/admin/upDateUder/${employee.employeeId}`)}
            className="btn ve-btn ve-btn-primary"
          >
            Edit Employee
          </button>
        </div>
      </div>

      <div className="card shadow-lg border-0 rounded-4 mb-4 ve-main-card">
        <div className="card-header text-center py-4 rounded-top-4 ve-hero">
          <h3 className="mb-0 fw-bold">Employee Profiless</h3>
        </div>

        <div className="card-body p-4">
          <div className="row mb-4">
            <div className="col-md-3 text-center ve-profile-col">
              {employee.img ? (
                <img src={employee.img} alt={employee.ename} className="rounded-circle border shadow ve-avatar" />
              ) : (
                <div className="rounded-circle text-white d-flex align-items-center justify-content-center mx-auto shadow ve-avatar ve-avatar-fallback">
                  {employee.ename?.charAt(0).toUpperCase()}
                </div>
              )}
              <h4 className="mt-3 mb-1">{employee.ename}</h4>
              <p className="text-muted">{employee.employeeId}</p>
              <span className="badge px-3 py-2 ve-type-badge">{employee.userType || "Employee"}</span>
            </div>

            <div className="col-md-9">
              <div className="mb-4">
                <h5 className="ve-section-title mb-3 border-bottom pb-2">Personal Information</h5>
                <div className="row g-3">
                  <div className="col-md-6"><div className="ve-info-item"><strong>Date of Birth:</strong><p className="mb-0">{formatDate(employee.dateOfBirth)}</p></div></div>
                  <div className="col-md-6"><div className="ve-info-item"><strong>Gender:</strong><p className="mb-0">{employee.gender}</p></div></div>
                  <div className="col-md-6"><div className="ve-info-item"><strong>Phone:</strong><p className="mb-0">{employee.phoneNo}</p></div></div>
                  <div className="col-md-6"><div className="ve-info-item"><strong>Personal Email:</strong><p className="mb-0">{employee.personal_email}</p></div></div>
                  <div className="col-md-6"><div className="ve-info-item"><strong>Official Email:</strong><p className="mb-0">{employee.official_email}</p></div></div>
                  <div className="col-md-6"><div className="ve-info-item"><strong>Father's Name:</strong><p className="mb-0">{employee.fatherName}</p></div></div>
                  <div className="col-md-6"><div className="ve-info-item"><strong>Mother's Name:</strong><p className="mb-0">{employee.motherName}</p></div></div>
                  <div className="col-md-6"><div className="ve-info-item"><strong>Address:</strong><p className="mb-0">{employee.address}</p></div></div>
                </div>
              </div>

              <div className="mb-4">
                <h5 className="ve-section-title mb-3 border-bottom pb-2">Emergency Contact</h5>
                <div className="row g-3">
                  <div className="col-md-6"><div className="ve-info-item"><strong>Contact Number:</strong><p className="mb-0">{employee.emergencyContact}</p></div></div>
                  <div className="col-md-6"><div className="ve-info-item"><strong>Relationship:</strong><p className="mb-0">{employee.relation}</p></div></div>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-4">
            <h5 className="ve-section-title mb-3 border-bottom pb-2">Bank Details</h5>
            <div className="row g-3">
              <div className="col-md-4"><div className="ve-info-item"><strong>Bank Name:</strong><p className="mb-0">{employee.bankName}</p></div></div>
              <div className="col-md-4"><div className="ve-info-item"><strong>Account Number:</strong><p className="mb-0">{employee.accountNo}</p></div></div>
              <div className="col-md-4"><div className="ve-info-item"><strong>IFSC Code:</strong><p className="mb-0">{employee.ifscCode}</p></div></div>
              <div className="col-md-6"><div className="ve-info-item"><strong>Bank Address or Branch Name:</strong><p className="mb-0">{employee.bankAddress || "N/A"}</p></div></div>
              <div className="col-md-6"><div className="ve-info-item"><strong>Account Holder:</strong><p className="mb-0">{employee.accountHolderName}</p></div></div>
            </div>
          </div>

          <div className="mb-4">
            <h5 className="ve-section-title mb-3 border-bottom pb-2">Identity Documents</h5>
            <div className="row g-3">
              <div className="col-md-4">
                <div className="ve-info-item">
                  <strong>Aadhaar Card:</strong>
                  <p className="mb-0">{employee.adarCardNo}</p>
                  {employee.aadhaarFile && (
                    <a href={employee.aadhaarFile} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-link p-0 mt-1">
                      📄 View Aadhaar Doc
                    </a>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="ve-info-item">
                  <strong>PAN Number:</strong>
                  <p className="mb-0">{employee.panNo}</p>
                  {employee.panFile && (
                    <a href={employee.panFile} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-link p-0 mt-1">
                      📄 View PAN Doc
                    </a>
                  )}
                </div>
              </div>
              <div className="col-md-4">
                <div className="ve-info-item">
                  <strong>Qualification:</strong>
                  <p className="mb-0">{employee.qualification}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-4">
            <h5 className="ve-section-title mb-3 border-bottom pb-2">Professional Details</h5>
            <div className="row g-3">
              <div className="col-md-3"><div className="ve-info-item"><strong>Department:</strong><p className="mb-0">{employee.department?.deptName || "N/A"}</p></div></div>
              <div className="col-md-3"><div className="ve-info-item"><strong>Service:</strong><p className="mb-0">{employee.service?.serviceName || "N/A"}</p></div></div>
              <div className="col-md-3"><div className="ve-info-item"><strong>Last Experience:</strong><p className="mb-0">{employee.lastExp}</p></div></div>
              <div className="col-md-3"><div className="ve-info-item"><strong>Exp with PWT:</strong><p className="mb-0">{employee.expWithPWT}</p></div></div>
              <div className="col-md-3"><div className="ve-info-item"><strong>Interview Date:</strong><p className="mb-0">{employee.interviewDate ? new Date(employee.interviewDate).toLocaleDateString() : "N/A"}</p></div></div>
              <div className="col-md-3"><div className="ve-info-item"><strong>Joining Date:</strong><p className="mb-0">{employee.joiningDate ? new Date(employee.joiningDate).toLocaleDateString() : "N/A"}</p></div></div>
              <div className="col-md-3"><div className="ve-info-item"><strong>Working Time:</strong><p className="mb-0">{employee.workingTime}</p></div></div>
            </div>
          </div>

          <div className="mb-4">
            <h5 className="ve-section-title mb-3 border-bottom pb-2">Salary Information</h5>
            <div className="row g-3">
              <div className="col-md-6"><div className="ve-info-item"><strong>Expected Salary:</strong><p className="mb-0 ve-salary-success">Rs {employee.expectedSalary?.toLocaleString() || "N/A"}</p></div></div>
              <div className="col-md-6"><div className="ve-info-item"><strong>Given Salary:</strong><p className="mb-0 ve-salary-primary">Rs {employee.givenSalary?.toLocaleString() || "N/A"}</p></div></div>
            </div>
          </div>

          <div className="mb-4">
            <h5 className="ve-section-title mb-3 border-bottom pb-2">Account Security & Monitoring</h5>
            <div className="row g-3 align-items-center">
              <div className="col-md-3">
                <div className="ve-info-item">
                  <strong>Account Status:</strong>
                  <p className="mb-0">
                    {employee.isLocked ? (
                      <span className="badge bg-danger">Locked 🔒</span>
                    ) : (
                      <span className="badge bg-success">Active ✅</span>
                    )}
                  </p>
                </div>
              </div>

              <div className="col-md-3 text-center">
                <div className="ve-info-item">
                  <strong>Inactivity Logouts (Monthly):</strong>
                  <div className="d-flex justify-content-center align-items-center gap-1 mt-1 mb-2">
                    <select
                      className="form-select form-select-sm"
                      style={{ width: "85px", fontSize: "0.75rem" }}
                      value={inactivityMonth}
                      onChange={(e) => setInactivityMonth(Number(e.target.value))}
                    >
                      {Array.from({ length: 12 }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                          {new Date(0, i).toLocaleString("default", { month: "short" })}
                        </option>
                      ))}
                    </select>
                    <select
                      className="form-select form-select-sm"
                      style={{ width: "70px", fontSize: "0.75rem" }}
                      value={inactivityYear}
                      onChange={(e) => setInactivityYear(Number(e.target.value))}
                    >
                      {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map((y) => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </select>
                  </div>
                  <p className="mb-0">
                    <span className="badge bg-warning text-dark">
                      {(() => {
                        const legacyCount = Math.max(0, (employee.inactivityLogoutCount || 0) - (employee.inactivityHistory?.length || 0));
                        let cnt = (employee.inactivityHistory || []).filter(d => {
                          const date = new Date(d);
                          return date.getMonth() + 1 === inactivityMonth && date.getFullYear() === inactivityYear;
                        }).length;
                        if (inactivityMonth === new Date().getMonth() + 1 && inactivityYear === new Date().getFullYear()) {
                          cnt += legacyCount;
                        }
                        return cnt;
                      })()} Attempts
                    </span>
                  </p>
                </div>
              </div>

              <div className="col-md-3 text-center">
                <div className="ve-info-item">
                  <strong>Inactivity Logouts (Daily):</strong>
                  <div className="d-flex justify-content-center align-items-center gap-1 mt-1 mb-2">
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      style={{ width: "130px", fontSize: "0.75rem" }}
                      value={inactivityDailyDate}
                      onChange={(e) => setInactivityDailyDate(e.target.value)}
                      max={new Date().toISOString().split("T")[0]}
                    />
                  </div>
                  <p className="mb-0">
                    <span className="badge bg-warning text-dark">
                      {(() => {
                        if (!inactivityDailyDate) return 0;
                        const targetDate = new Date(inactivityDailyDate);
                        const cnt = (employee.inactivityHistory || []).filter(d => {
                          const date = new Date(d);
                          return date.getFullYear() === targetDate.getFullYear() &&
                            date.getMonth() === targetDate.getMonth() &&
                            date.getDate() === targetDate.getDate();
                        }).length;
                        return cnt;
                      })()} Attempts
                    </span>
                  </p>
                </div>
              </div>

              <div className="col-md-3">
                <div className="ve-info-item">
                  <strong>Screenshot Interval:</strong>
                  <select
                    className="form-select form-select-sm mt-1"
                    value={String(employee.screenshotInterval ?? 300)}
                    onChange={(e) => handleUpdateSettings("interval", e.target.value)}
                    disabled={updatingInterval}
                  >
                    <option value="5">5 Seconds</option>
                    <option value="10">10 Seconds</option>
                    <option value="60">1 Minute</option>
                    <option value="300">5 Minutes</option>
                    <option value="900">15 Minutes</option>
                    <option value="1800">30 Minutes</option>
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="ve-info-item">
                  <strong>Inactivity Timeout:</strong>
                  <select
                    className="form-select form-select-sm mt-1"
                    value={String(employee.inactivityTimeout ?? 300)}
                    onChange={(e) => handleUpdateSettings("timeout", e.target.value)}
                    disabled={updatingInterval || currentUser?.role !== "superadmin"}
                  >
                    <option value="10">10 Seconds (Testing)</option>
                    <option value="60">1 Minute</option>
                    <option value="300">5 Minutes</option>
                    <option value="600">10 Minutes</option>
                    <option value="1800">30 Minutes</option>
                    <option value="3600">1 Hour</option>
                  </select>
                </div>
              </div>

              <div className="col-md-3 text-end">
                <button
                  className="btn ve-btn ve-btn-primary btn-sm"
                  onClick={handleGenerateCode}
                  disabled={generatingCode}
                >
                  {generatingCode ? "Generating..." : employee.isLocked ? "Regenerate OTP" : "Lock Account"}
                </button>
              </div>

              {employee.isLocked && employee.unlockOTP && (
                <div className="col-12 mt-2">
                  <div className="alert alert-warning mb-0 py-2">
                    <strong>Unlock Code:</strong> <span className="ms-2 fw-bold text-dark">{employee.unlockOTP}</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="mb-4">
            <h5 className="ve-section-title mb-3 border-bottom pb-2">Documents</h5>
            <div className="row g-3">
              <div className="col-md-12">
                {employee.resumeFile ? (
                  <a
                    href={employee.resumeFile}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn ve-btn ve-btn-secondary"
                  >
                    Download Resume
                  </a>
                ) : (
                  <span className="text-muted">No Resume Available</span>
                )}
              </div>
            </div>
          </div>

          {/* 🎥 Screen Activity Tracker Timeline */}
          <div className="mb-4 ve-activity-section border-top pt-4">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
              <h5 className="ve-section-title mb-2">🎥 Screen Activity Timeline (Last 15 Days)</h5>
              <div className="d-flex align-items-center gap-2 mb-2">
                <span className="text-muted small">Select Date:</span>
                <input
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  className="form-control form-control-sm ve-date-picker"
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>
            </div>

            {loadingScreenshots ? (
              <div className="text-center py-4">
                <div className="spinner-border spinner-border-sm text-secondary" role="status">
                  <span className="visually-hidden">Loading screenshots...</span>
                </div>
              </div>
            ) : screenshots.length > 0 ? (
              <div className="row g-3 ve-screenshots-grid">
                {screenshots.map((s, index) => (
                  <div key={index} className="col-sm-6 col-md-4 col-lg-3">
                    <div
                      className="card h-100 ve-screenshot-card border shadow-sm"
                      onClick={() => setSelectedScreenshot(s)}
                    >
                      <div className="ve-screenshot-img-wrapper position-relative">
                        <img
                          src={s.imageBuffer}
                          alt={`Captured at ${new Date(s.createdAt).toLocaleTimeString()}`}
                          className="card-img-top ve-screenshot-thumb"
                        />
                        <div className="ve-screenshot-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center gap-2">
                          <span className="btn btn-sm btn-light shadow-sm" onClick={(e) => { e.stopPropagation(); setSelectedScreenshot(s); }}>
                            View
                          </span>
                          <button
                            className="btn btn-sm btn-danger shadow-sm"
                            onClick={(e) => { e.stopPropagation(); handleDeleteScreenshot(s._id); }}
                            title="Delete Screenshot"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                      <div className="card-body p-2 d-flex flex-column justify-content-between" onClick={() => setSelectedScreenshot(s)}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span className="badge bg-secondary text-light ve-time-badge">
                            {new Date(s.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                          </span>
                          <span className="badge bg-success-subtle text-success ve-status-badge">
                            Active 🟢
                          </span>
                        </div>
                        <div className="text-muted small text-truncate" title={s.currentRoute || "/"}>
                          Route: <strong>{s.currentRoute || "/"}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="alert alert-light text-center py-4 border rounded-3 ve-empty-alert">
                No activity screenshots recorded for this date.
                <br />
                <span className="text-muted small">Note: Captures auto-expire after 15 days, or the employee may have been offline / idle.</span>
              </div>
            )}
          </div>

          {/* 🔍 Zoom / Lightbox Full Screen Modal */}
          {selectedScreenshot && (
            <div
              className="modal fade show d-block ve-lightbox-modal"
              tabIndex="-1"
              onClick={() => setSelectedScreenshot(null)}
            >
              <div className="modal-dialog modal-dialog-centered modal-xl" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
                  <div className="modal-header bg-dark text-white border-0 py-2 px-3 d-flex justify-content-between align-items-center">
                    <h6 className="modal-title mb-0 fw-bold">
                      📸 captured: {new Date(selectedScreenshot.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })} (Route: {selectedScreenshot.currentRoute || "/"})
                    </h6>
                    <button
                      type="button"
                      className="btn-close btn-close-white"
                      onClick={() => setSelectedScreenshot(null)}
                    ></button>
                  </div>
                  <div className="modal-body p-0 bg-secondary-subtle text-center">
                    <img
                      src={selectedScreenshot.imageBuffer}
                      alt="Full screen capture"
                      className="img-fluid ve-screenshot-full"
                    />
                  </div>
                </div>
              </div>
              <div className="modal-backdrop fade show"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ViewEmployee;
